var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-sidebar"},[_c('logo',{attrs:{"is-mini-sidebar":_vm.isMiniSidebar},on:{"image-clicked":_vm.imageClicked}}),_c('menu-list',{attrs:{"items":_vm.menuItems,"is-mini-sidebar":_vm.isMiniSidebar}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }